import { Grid, Stack, Typography } from "@mui/material";
import { Image } from "../../../fe-ui/atoms/Image";
import { Iconify } from "../../../fe-ui/atoms/Iconify";
import { Link } from "../../../fe-ui/atoms/Link/Link";
import { ContentRendererBody } from "./ContentRendererBody";

interface Props {
  backgroundColor?: string | null;
  body?: any;
  gridWidth?: number;
  icon?: string | null;
  isCentered?: boolean | null;
  linkText?: string | null;
  linkUrl?: string | null;
  media?: any;
  title?: string | null;
  variant?: "h3" | "h5" | null;
  isForAgreementGeneration?: boolean;
}

export function ContentRendererCard(props: Props) {
  const {
    backgroundColor,
    body,
    gridWidth,
    icon,
    isCentered,
    linkText,
    linkUrl,
    media,
    title,
    variant,
    isForAgreementGeneration,
  } = props || {};

  return (
    <Grid item xs={12} md={gridWidth || 4}>
      <Stack
        direction="column"
        alignItems={isCentered ? "center" : "flex-start"}
        spacing={variant === "h5" ? 1 : 2}
        sx={[
          { height: "100%" },
          isCentered ? { textAlign: "center" } : null,
          backgroundColor
            ? {
                backgroundColor,
                borderRadius: 2,
                padding: 3,
              }
            : null,
          backgroundColor === "white"
            ? {
                boxShadow: "0px 0px 2px 0px rgba(145, 158, 171, 0.20), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)",
              }
            : null,
        ]}
      >
        {icon ? <Iconify width={64} icon={icon} sx={{ color: "primary.main", mb: 1 }} /> : null}
        {media?.data?.attributes?.url ? <Image draggable={false} src={media?.data?.attributes?.url} /> : null}
        {title ? <Typography variant={variant || "h3"}>{title}</Typography> : null}
        {body ? (
          <ContentRendererBody
            body={body}
            paragraphVariant={variant === "h5" ? "body1" : "bodyLg"}
            paragraphSx={{ flexGrow: 1 }}
            isForAgreementGeneration={isForAgreementGeneration}
          />
        ) : null}
        {linkText ? (
          <Stack alignItems="center" spacing={0.5} direction="row" sx={{ pb: 1, pt: 2, px: 1.5 }}>
            <Link color="primary.main" href={linkUrl || ""} sx={{ fontWeight: 600 }}>
              {linkText}
            </Link>
            <Iconify color="primary.main" width={24} icon="ic:baseline-chevron-right" />
          </Stack>
        ) : null}
      </Stack>
    </Grid>
  );
}
